import React from 'react'
import classNames from 'classnames'
import classes from './Hero.module.css'
import gridClasses from '../../styles/grid.module.css'

export const HeroTitle = ({
    children,
    large = false,
    centered = false,
    className,
    ...props
}) => (
    <h1
        className={classNames(
            classes.heroTitle,
            centered && classes.centered,
            large && classes.heroTitleLarge,
            className
        )}
        {...props}
    >
        {children}
    </h1>
)

export const HeroSubtitle = ({
    children,
    className,
    centered = false,
    ...props
}) => (
    <p
        className={classNames(
            classes.heroSubtitle,
            centered && classes.centered,
            className
        )}
        {...props}
    >
        {children}
    </p>
)

export const HeroContent = ({
    children,
    leftAligned = false,
    centered = false,
    className,
    ...props
}) => {
    if (leftAligned && centered) {
        throw new Error(
            `HeroContent cannot be left aligned and centered at the same time`
        )
    }
    return (
        <div
            className={classNames(
                classes.heroContent,
                leftAligned && classes.heroContentLeft,
                centered && classes.heroContentCentered,
                className
            )}
            {...props}
        >
            {children}
        </div>
    )
}

export const HeroMedia = ({ children, className, ...props }) => (
    <div className={classNames(classes.heroMedia, className)} {...props}>
        <div className={classes.heroMediaContent}>{children}</div>
    </div>
)

export const HeroDivider = ({ className, ...props }) => (
    <div className={classNames(classes.heroDivider, className)} {...props} />
)

export const HeroBackground = ({ className, src, color, ...props }) => (
    <div className={classNames(classes.heroBackground, className)}>
        <div
            className={classes.heroBackgroundImage}
            style={{
                backgroundColor: color,
                backgroundImage: `url(${src})`,
            }}
        />
    </div>
)

export const Hero = ({
    children,
    className,
    header,
    background,
    // headerSpacing = '115px',
    // bottomSpacing = '60px',
    ...props
}) => (
    <div
        className={classNames(
            classes.hero,
            background && classes.withBackground,
            className
        )}
        {...props}
    >
        {background}
        {header}
        <div
            className={classNames(
                gridClasses.container,
                classes.heroContainer,
                header && classes.withHeader
            )}
        >
            {children}
        </div>
    </div>
)
